import React from 'react'
import { Button } from 'antd'
import { CloseOutlined, MinusOutlined } from '@ant-design/icons'

const UtilityDrawerHeader = ({onClose, onMinimize, headerTitle}) => {
  return (
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', height: '14px' }}>
        <h5>{headerTitle}</h5>
        <div>
          <Button size='small' icon={<MinusOutlined/>} onClick={onMinimize} style={{ border: 'none', boxShadow: 'none' }}></Button>
          <Button size='small' icon={<CloseOutlined/>} onClick={onClose} style={{ border: 'none', boxShadow: 'none' }}></Button>
        </div>
    </div>
  )
}

export default UtilityDrawerHeader